import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

export interface WikiSectionNode {
  id: string;
  title: string;
  slug: string;
  anchor_id: string;
  order_index: number;
  content_md: string;
  tags: string[];
  children: WikiSectionNode[];
}

export interface WikiPageData {
  posit: {
    id: string;
    title: string;
    privacy: string | null;
    created_at: string;
    updated_at: string;
  };
  seo: {
    is_public: boolean;
    slug: string | null;
  };
  lead: string | null;
  sections: WikiSectionNode[];
}

export const useWikiPage = (positId: string | undefined) => {
  return useQuery({
    queryKey: ['wiki-page', positId],
    enabled: Boolean(positId),
    queryFn: async (): Promise<WikiPageData> => {
      const { data, error } = await supabase.functions.invoke('get-wiki-page', {
        body: { posit_id: positId }
      });

      if (error) {
        throw new Error(error.message || 'Failed to fetch wiki page');
      }
      if (!data?.success) {
        throw new Error(data?.error || 'Failed to fetch wiki page');
      }
      return data.data as WikiPageData;
    }
  });
};


